import * as React from 'react';
import FormControlUnstyledContext from './FormControlUnstyledContext';
export default function useFormControlUnstyledContext() {
  return React.useContext(FormControlUnstyledContext);
}